import keymirror from "../utils/keymirror";

export const PostActionSnackbarConstants = keymirror(
    {
        CLEAR_SNACKBAR: null
    },
    "post-action-snackbar"
);



// WEBPACK FOOTER //
// ./src/constants/postActionSnackbar.constants.js